export const getWebsiteBoardCounts = board => {
  if (!board?.columns) return null;

  const columns = {};
  Object.entries(board.columns).forEach(([id, column]) => {
    const title = column.title || id;
    columns[title] = (columns[title] || 0) + (column.items || []).length;
  });
  return { columns };
};
